import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    latestIREvent: null,
    eventType: null,
};

const irWebSocketSlice = createSlice({
    name: 'irWebSocket',
    initialState,
    reducers: {
        setIREvent: (state, action) => {
            state.latestIREvent = action.payload.data;
            state.eventType = action.payload.eventType;
        },
        clearIREvent: (state) => {
            state.latestIREvent = null;
            state.eventType = null;
        }
    }
});

export const { setIREvent, clearIREvent } = irWebSocketSlice.actions;
export default irWebSocketSlice.reducer;